import { ReactElement } from "react"

import { GenericCreateCommentsComponent } from "../genericComments/genericCreateComment"

interface IAddApplicationCommentComponentProps {
    applicationId: string
    mutate: () => void
    isLoading: boolean
    isDno: boolean
    commentStatus: boolean
    createComment: (
        applicationId: string,
        comment: string,
        isDno: boolean
    ) => Promise<void>
    readComment: (
        applicationId: string,
        read: boolean,
        isDno: boolean,
        resetSwitchOnFail?: () => void
    ) => Promise<void>
    lastReadBy?: string
    lastReadAt?: string
}

/** Component for adding a comment to a DNO or Installer application */
export const AddApplicationComment = ({
    applicationId,
    mutate,
    isLoading,
    createComment,
    isDno,
    readComment,
    commentStatus,
    lastReadBy,
    lastReadAt,
}: IAddApplicationCommentComponentProps): ReactElement => {
    const addComment = (comment: string): Promise<void> =>
        createComment(applicationId, comment, isDno)

    const markAsRead = (
        read: boolean,
        resetSwitchOnFail: () => void
    ): Promise<void> =>
        readComment(applicationId, read, isDno, resetSwitchOnFail)
    return (
        <GenericCreateCommentsComponent
            mutate={mutate}
            isLoading={isLoading}
            createComment={addComment}
            markAsRead={markAsRead}
            isThreadUnread={commentStatus}
            lastReadBy={lastReadBy}
            lastReadAt={lastReadAt}
        />
    )
}

AddApplicationComment.defaultProps = {
    lastReadBy: undefined,
    lastReadAt: undefined,
}
